<template>
  <div id="gota-kanal-app">
    <SiteHeader />
    <router-view />
    <TransitionGroup
      name="toast"
      tag="div"
      class="toast-stack"
      aria-live="polite"
      aria-atomic="true"
      aria-label="Notifications">
      <Toast
        v-for="toast in toasts"
        :key="toast.id"
        :toast="toast"
        @close="removeToast(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import Toast from "@components/Toast/Toast.vue";
import { useToast } from "@components/Toast/toast-service";
import SiteHeader from "@shared/Layout/SiteHeader/SiteHeader.vue";

const { toasts, removeToast } = useToast();
</script>
